"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coachLinkSchema = void 0;
const zod_1 = require("zod");
exports.coachLinkSchema = zod_1.z.object({
    id: zod_1.z.string(),
    coachId: zod_1.z.string(),
    clientId: zod_1.z.string()
});
